import {defineStore} from "pinia/dist/pinia";
import AppService from "@/service/AppService";

export const useApplicationStore = defineStore('ApplicationStore', {
    state() {
        return {
            appService: new AppService(),
            baseCookiesState: localStorage.baseCookies === 'true',
            analyticsCookiesState: localStorage.analyticsCookies === 'true',
            marketingCookiesState: localStorage.marketingCookies === 'true',
            recommendationsState: [
                {
                    "class": "title",
                    "code": "1",
                    "label": "Title",
                    "children": [
                        {
                            "class": "recommendation",
                            "code": "1.1",
                            "label": "Concisely include relevant key terms referring to the study type, study population, objectives, data sources and outcomes, depending on the study. Consider including the terms ‘real-world’ or ‘observational’",
                            "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                        }
                    ]
                },
                {
                    "class": "title",
                    "code": "2",
                    "label": "Introduction",
                    "children": [
                        {
                            "class": "recommendation",
                            "code": "2.1",
                            "label": "Explain the scientific rationale for the research question(s), providing concise background information on previous core evidence from systematic reviews, meta-analyses, clinical trials and/or real-world evidence studies",
                            "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                        },
                        {
                            "class": "recommendation",
                            "code": "2.2",
                            "label": "Identify the gaps in evidence and explain why and how they can be suitably addressed by real-world evidence research. Specify the new evidence that is expected from the current study",
                            "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                        },
                        {
                            "class": "recommendation",
                            "code": "2.3",
                            "label": "Briefly introduce the aim(s) of the study",
                            "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                        }
                    ]
                },
                {
                    "class": "title",
                    "code": "3",
                    "label": "Methods",
                    "children": [
                        {
                            "class": "sub-title",
                            "code": "3",
                            "label": "Study objective(s), design, data sources and variables",
                            "children": [
                                {
                                    "class": "recommendation",
                                    "code": "3.1",
                                    "label": "Provide the study research question(s) including a description of the patients or the object under study and the target outcome(s)",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "3.2",
                                    "label": "Provide the study objective(s) and consider classifying the type of research as descriptive and/or analytical (explanatory or predictive)",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "3.3",
                                    "label": "Provide relevant information to describe and classify the study design used to address the research question",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "3.4",
                                    "label": "Give a clear definition of the eligibility criteria used to select the patients or objects under study, particularly regarding cancer-related aspects",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "3.5",
                                    "label": "Report the specific type and purpose of real-world data source(s) used, providing a detailed description and the reason(s) why the source was considered appropriate for the study objectives",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "3.6",
                                    "label": "When multiple real-world data sources are used, provide details on interoperability, including identification of duplicated cases or data linkage from separate databases",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "3.7",
                                    "label": "Provide details and timings of source and study data management. Consider specifying methods of raw data collection, updates and completeness, data extraction, cleaning and/or quality controls and validation",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "3.8",
                                    "label": "Provide core details on database and/or study registration, governance, ownership, metadata and full data accessibility in the main text or supplementary material",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "3.9",
                                    "label": "Identify the data source of each core variable, its definition, if the variable was derived or coded, and describe how the derivation or coding was conducted and validated",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "3.10",
                                    "label": "Specify the time points of core variables in relation to the cancer disease trajectory",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "3.11",
                                    "label": "Provide a complete list of core variables included in the study. Variables can be grouped as baseline characteristics, exposure, and outcomes or endpoints",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "3.12",
                                    "label": "For biomarker-related studies, provide details on biomarker description, timing, and methods of assessment and analytical validation",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                }
                            ]
                        },
                        {
                            "pageBreak": true,
                            "class": "sub-title",
                            "code": "3",
                            "label": "Statistical analysis and artificial intelligence methods ",
                            "children": [
                                {
                                    "class": "recommendation",
                                    "code": "3.13",
                                    "label": "Summarise the main aspects of the statistical analysis",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "3.14",
                                    "label": "When applicable, provide details on the pre-planned sample size requirements and power of the study",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "3.15",
                                    "label": "Specify the pre-planned strategies to identify and mitigate the main sources of bias",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "3.16",
                                    "label": "Clearly distinguish prespecified from post hoc analyses, especially for subgroup analyses",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "3.17",
                                    "label": "Provide information on internal and external validity, as well as any sensitivity analyses",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "3.18",
                                    "label": "For analytical studies, the full version of the statistical analysis plan should be provided in the supplementary material, including a brief explanation of any amendments",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "3.19",
                                    "label": "When applicable, specify which machine learning, deep learning or alternative artificial intelligence method has been used",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "3.20",
                                    "label": "When reporting real-world data analysis with artificial intelligence (e.g. machine learning and deep learning) algorithms, include comprehensive aspects on data pre-processing techniques, feature engineering strategies and model development",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "3.21",
                                    "label": "Address the artificial intelligence model explainability and interpretability, and present the plan for integration into clinical practice, if applicable",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "3.22",
                                    "label": "When applicable, briefly describe the multidisciplinary team required for the study and explain how these needs were met",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                }
                            ]
                        }
                    ]
                },
                {
                    "class": "title",
                    "code": "4",
                    "label": "Results",
                    "children": [
                        {
                            "class": "recommendation",
                            "code": "4.1",
                            "label": "Provide the number of cases excluded or nonparticipating and reasons at each stage of sample selection, as well as numbers lost to follow-up. Compare the cases excluded with those included in the analyses. Illustrate this with a flowchart",
                            "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                        },
                        {
                            "class": "recommendation",
                            "code": "4.2",
                            "label": "Describe the baseline characteristics of the cases included (e.g. clinico-demographic and tumour characteristics). The baseline characteristics of different groups under analysis should be compared, if applicable",
                            "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                        },
                        {
                            "class": "recommendation",
                            "code": "4.3",
                            "label": "Report the results of the primary analysis of study outcomes. Briefly describe the results of exploratory analyses if relevant (prespecified and/or post hoc). Provide details of how readers can access the full results",
                            "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                        }
                    ]
                },
                {
                    "class": "title",
                    "code": "5",
                    "label": "Discussion and conclusions",
                    "children": [
                        {
                            "class": "sub-title",
                            "code": "5",
                            "label": "Discussion",
                            "children": [
                                {
                                    "class": "recommendation",
                                    "code": "5.1",
                                    "label": "Summarise the core results that address the primary research question(s) and objectively discuss the data in relation to the best available evidence on the topic. Avoid a convenient selection of literature to support a point",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "5.2",
                                    "label": "Discuss the strengths and limitations of the current study, including the main biases, how the strategies applied contributed to bias avoidance or mitigation, and, if applicable, in which direction the authors estimate that residual bias may influence the core results of the study",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                },
                                {
                                    "class": "recommendation",
                                    "code": "5.3",
                                    "label": "Discuss the generalisability of the study results and their potential implications for clinical practice, health policies or public health and for the generation of hypotheses for future research",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                }
                            ]
                        },
                        {
                            "class": "sub-title",
                            "code": "5",
                            "label": "Conclusions",
                            "children": [
                                {
                                    "class": "recommendation",
                                    "code": "5.4",
                                    "label": "Provide a balanced summary of core results relating to the primary research question and the main implications for clinical practice, health policies and/or public health. Suggest further research considering the remaining unmet needs and limitations from the reported study",
                                    "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                                }
                            ]
                        }
                    ]
                },
                {
                    "class": "title",
                    "code": "6",
                    "label": "Final considerations",
                    "children": [
                        {
                            "class": "recommendation",
                            "code": "6.1",
                            "label": "Specify all relevant study sponsorship(s) as well as direct and/or indirect or in-kind funding",
                            "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                        },
                        {
                            "class": "recommendation",
                            "code": "6.2",
                            "label": "Specify all relevant acknowledgements, author disclosures, individual contributions and other final considerations as per journal regulations",
                            "link": "https://www.annalsofoncology.org/article/S0923-7534(23)04018-8/fulltext"
                        }
                    ]
                }
            ],
            stepsProgressState: {"lastUpdate": null, "steps": []},
            currentStepState: 0,
            titleState: null,
            roleState: null,
            rolesState: [
                {name: 'Author', code: 'author'},
                {name: 'Reviewer', code: 'reviewer'},
                {name: 'Reader', code: 'reader'}
            ],
            nameState: null,
            emailState: null,
            informativeScoreIdState: null,
        }
    },
    getters: {
        roles() {
            return this.rolesState;
        },
        informativeScoreId() {
            return this.informativeScoreIdState
        },
        title() {
            return this.titleState
        },
        role() {
            return this.roleState
        },
        name() {
            return this.nameState
        },
        email() {
            return this.emailState
        },
        currentStep() {
            return this.currentStepState
        },
        baseCookies() {
            return this.baseCookiesState
        },
        analyticsCookies() {
            return this.analyticsCookiesState
        },
        marketingCookies() {
            return this.marketingCookiesState
        },
        recommendations() {
            return this.recommendationsState
        },
        stepsProgress() {
            return this.stepsProgressState
        }
    },
    actions: {
        setInformativeScoreId(informativeScoreId) {
            this.informativeScoreIdState = informativeScoreId
        },
        setTitle(title) {
            this.titleState = title
        },
        setName(name) {
            this.nameState = name
        },
        setEmail(email) {
            this.emailState = email
        },
        setRole(role) {
            this.roleState = role
        },
        setCurrentStep(currentStep) {
            this.currentStepState = currentStep
        },
        setBaseCookies(baseCookies) {
            this.baseCookiesState = baseCookies;
            localStorage.baseCookies = baseCookies;
        },
        setAnalyticsCookies(analyticsCookies) {
            this.analyticsCookiesState = analyticsCookies;
            localStorage.analyticsCookies = analyticsCookies;
        },
        setMarketingCookies(marketingCookies) {
            this.marketingCookiesState = marketingCookies;
            localStorage.marketingCookies = marketingCookies;
        },
        setStepsProgress(stepsProgress) {
            this.stepsProgressState = stepsProgress
        },
        generateInformativeScorePdf(informativeScore) {
            return this.appService.generateInformativeScorePdf(informativeScore);
        },
        upsertInformativeScore(informativeScore) {
            return this.appService.upsertInformativeScore(informativeScore);
        },
        shareInformativeScorePdf(informativeScore, email) {
            return this.appService.shareInformativeScorePdf(informativeScore, email);
        },
        sendInformativeScoreToken(informativeScore, email) {
            return this.appService.sendInformativeScoreToken(informativeScore, email);
        },
        insertFeedback(feedback) {
            return this.appService.insertFeedback(feedback);
        },
        informativeScoreByUUID(uuid) {
            return this.appService.informativeScoreByUUID(uuid);
        },
        initialiseSteps() {
            const stepsFromElements = (elements, steps, breadcrumb) => {
                elements.forEach(element => {
                    if (element.children != null) {
                        if (element.children.some(child => child.class === 'recommendation')) {
                            steps.push({
                                "pageBreak": element.pageBreak != null ? element.pageBreak : false,
                                "breadcrumb": breadcrumb,
                                "code": element.code,
                                "label": element.label,
                                "children": element.children,
                                "childrenCompleted": 0,
                                "childrenNotApplicable": 0,
                                "childrenScore": 0
                            })
                        }
                        stepsFromElements(element.children, steps, [].concat(breadcrumb, [element.label]))
                    }
                })
                return steps
            }
            this.setStepsProgress({
                "lastUpdate": new Date().getTime(),
                "steps": stepsFromElements(this.recommendationsState, [], ["Home"])
            })
        }
    },
    persist: {
        storage: sessionStorage
    }
})
